import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LanguagesService } from '../services/languages.service';

@Component({
    selector: 'platform-confirm-dialog',
    standalone: true,
    imports: [CommonModule, ButtonModule],
    template: `
        <div [ngClass]="['flex', 'flex-column', styleClass]">
            <div class="flex justify-content-end">
                <p-button [label]="buttonText" (onClick)="handleClick()" styleClass="w-full height-44"></p-button>
            </div>
        </div>
    `,
    styles: [``],
})
export class ConfirmDialogComponent {
    private dialogRef = inject(DynamicDialogRef);
    private config = inject(DynamicDialogConfig);
    languageService = inject(LanguagesService);
    buttonText!: string;
    styleClass: string = '';
    ngOnInit() {
        this.buttonText = this.config?.data?.buttonText;
        this.styleClass = this.config?.data?.styleClass ?? '';
    }

    handleClick() {
        this.dialogRef.close(true);
    }
}
